<script>
  import page from 'page';
  import { onMount } from 'svelte';
  import APIClient from '../state-charts/api-client';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import session from '../lib/session.js';
  import AuthenticatedLayout from '../app-shell/authorized-app/Layout.svelte';
  import DialogDocument from './components/DialogDocument.svelte';
  import Dialog from '../lib/components/Dialog.svelte';

  // component options  ------------------------------------------------------ //

  export let route_name;
  export let query;

  // internal variables ------------------------------------------------------ //

  let dialog;
  let documents = [];
  let document_types;
  let disabled = false;

  // utility functions ------------------------------------------------------ //

  const init_documents = () => {
    document.querySelector('.mdc-top-app-bar--fixed-adjust').scrollIntoView({behavior: "smooth"})
    load_documents();

    if (documents.length === document_types.length) {
      disabled = true;
    } else {
      document_types.forEach(value => {
        value.val = value.document_type;
        value.name = get_docu_type_str(value.document_type);
      });
      let docu_types = [];

      document_types.forEach(e => {
        let is_exist = false;
        documents.forEach(d => {
          if (e.document_type === d.document_type) {
            is_exist = true;
          }
        });
        if (!is_exist) docu_types.push(e);
      });

      document_types = docu_types;
    }
  };

  const load_documents = () => {
    documents = $session.user.documents;
    document_types = $session.merchant.document_types;
    disabled = documents.length === document_types.length;
  };

  const check_disabled = documents => {
    disabled = documents.length === document_types.length;
  };

  const get_docu_type_str = docu_type => {
    let types = $session.merchant.document_types;
    let docu = types.filter(value => value.document_type === docu_type);

    let lang = $session.language;

    switch (lang) {
      case 'ar':
        return docu[0].localized_names.translation_ar;
      case 'en':
        return docu[0].localized_names.translation_en;
      case 'fa':
        return docu[0].localized_names.translation_fa;
      case 'fi':
        return docu[0].localized_names.translation_fi;
      case 'ru':
        return docu[0].localized_names.translation_ru;
      case 'sv':
        return docu[0].localized_names.translation_sv;
      case 'uk':
        return docu[0].localized_names.translation_uk;
    }
  };

  const get_img_url = url => {
    return `${location.origin}${url}`;
  };

  const open_dialog_delete = index => {
    let target = document.querySelector('.dialog-docu-delete');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'deletedialogedu',
        title: t9n(TS.DOCUMENTS_DELETE),
        content: t9n(TS.TXT_ARE_YOU_SURE),
        buttons: [
          {
            label: t9n(TS.TXT_CANCEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: t9n(TS.TXT_YES),
            action: async () => {
              await delete_document(index);
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });
    dialog.open();
  };

  const open_dialog_document = () => {
    let target = document.querySelector('.add-dialog');
    target.innerHTML = '';

    dialog = new DialogDocument({
      target: target,
      props: {
        config: $session,
        load_documents: load_documents,
        documents: documents,
        id: 'docu-dialog',
        title: 'dialog_title',
        content: 'dialog_content',
        buttons: [
          {
            label: 'OK',
            action: () => {
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });
    dialog.open();
  };

  const edit_document = index => {
    let target = document.querySelector('.add-dialog');
    target.innerHTML = '';

    let document_edit = documents[index];
    dialog = new DialogDocument({
      target: target,
      props: {
        config: $session,
        load_documents: load_documents,
        documents: documents,
        is_edit: true,
        document_edit: document_edit,
        id: 'docu-dialog',
        title: 'dialog_title',
        content: 'dialog_content',
        buttons: [
          {
            label: 'OK',
            action: () => {
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });
    dialog.open();
  };

  const delete_document = async index => {
    let document_type = documents[index].document_type;
    let data = {
      document_type: document_type,
    };
    let result = await APIClient.delete_document(data);
    if (!!result) {
      load_documents();
    }
  };

  let labels = {
    headline: null,
    tooltip: null,
    header_document: null,
    header_status: null,
    header_info: null,
    no_result: null,
    btn_add: null,
    comment: null,
  };

  const translate_texts = () => {
    labels.headline = t9n(TS.DOCUMENTS_NAME);
    labels.tooltip = t9n(TS.DOCUMENTS_TOOLTIP);
    labels.header_document = t9n(TS.DOCUMENTS_NAME_HEADER);
    labels.header_status = t9n(TS.TABLE_HEADER_STATUS);
    labels.header_info = t9n(TS.DOCUMENTS_INFO_HEADER);
    labels.no_result = t9n(TS.TABLE_NO_RESULT);
    labels.btn_add = t9n(TS.ORDERER_TEAMS_ADD_LABEL);
    labels.comment = t9n(TS.PILOT_POINTS_HISTORY_COMMENT_LABEL);
  };

  $: if (!!$session) translate_texts();

  onMount(init_documents);
</script>

  <main class="main--global wrapper fade-in">
    <div class='mobile-padding'>
      <!-- Title -->
      <div style="text-align: center;">
        <h1 style="margin-bottom: 25px" class="mdc-typography--headline5">
          {labels.headline}
        </h1>
      </div>

      <!-- Help line -->
      <div id="help-liner" class="mobile-margin">
        <div class="tooltip-default ">
          <span id="tooltip_def" class="tooltip-text tooltip-top">
            {labels.tooltip}
          </span>
        </div>
      </div>

      <!-- Actual documents -->
      <table id="documents" class="table">
        <!-- Head -->
        <tr class="tr-head">
          <td style="width: 20%" class="height padding">
            {labels.header_document}
          </td>
          <td style="width: 20%" class="padding" />
          <td style="width: 10%" class="padding">{labels.header_status}</td>
          <td style="width: 25%" class="padding">{labels.header_info}</td>
          <td style="width: 25%" class="padding">{labels.comment}</td>
        </tr>
        <!-- First row -->
        {#if documents.length > 0}
          {#each documents as document, index}
            <tr class="mdc-card-documents mdc-data-table__row fade-in">
              <td
                class="mdc-data-table__cell cell-pointer mobile-width"
                style="white-space: pre-line;"
                on:click={() => edit_document(index)}>
                <p>
                  {#if !!get_docu_type_str(document.document_type)}
                    {get_docu_type_str(document.document_type)}
                  {/if}
                  <!--{t9n(TS.DRIVING)}-->
                </p>
              </td>
              <td
                class="mdc-data-table__cell cell-pointer mobile-width"
                style="white-space: pre-line;"
                on:click={() => edit_document(index)}>
                <!--{#if image}-->
                <img
                  src={get_img_url(document.image_url)}
                  height="90"
                  width="90"
                  alt="document" />
              </td>
              <td
                class="mdc-data-table__cell cell-pointer mobile-width"
                style="white-space: pre-line;"
                on:click={() => edit_document(index)}>
                <p
                  class:status-pending={document.status === 'doc_status_pending'}
                  class:status-verified={document.status === 'doc_status_verified'}
                  class:status-rejected={document.status === 'doc_status_rejected'}
                  class:status-expired={document.status === 'doc_status_expired'}>
                  {t9n(document.status)}
                </p>
              </td>
              <td
                class="mdc-data-table__cell cell-pointer mobile-width"
                style="white-space: pre-line;"
                on:click={() => edit_document(index)}>
                {#if !!document.message}{document.message}{/if}
              </td>
              <td
                class="mdc-data-table__cell cell-pointer mobile-width"
                style="white-space: pre-line;"
                on:click={() => edit_document(index)}>
                {#if !!document.admin_comment}{document.admin_comment}{/if}
              </td>

              <td
                style="position: relative"
                on:click={() => open_dialog_delete(index)}>
                <i class="material-icons delete-icon" aria-hidden="true">close</i>
              </td>
            </tr>
          {/each}
        {:else}
          <tr class="mdc-card-documents mdc-data-table__row fade-in">
            <td
              class="mdc-data-table__cell mobile-width"
              style="white-space: pre-line;">
              <p>{labels.no_result}</p>
            </td>
          </tr>
        {/if}

        <!-- 2nd row -->
      </table>

      <div style="display: flex; justify-content: flex-end">
        <button
          {disabled}
          on:click|stopPropagation|preventDefault={() => open_dialog_document()}
          class="fade-in mdc-button mdc-button--unelevated margin-5">
          <span class="mdc-button__ripple" />
          {labels.btn_add}
        </button>
      </div>
    </div>

    <div class="add-dialog" />
    <div class="dialog-docu-delete" />

  </main>

<style type="text/scss">
  img {
    border-radius: 5%;
    margin-left: 15px;
    margin-top: 10px;
    margin-bottom: 6px;
    vertical-align: middle;
    box-shadow: 0px 2px 1px 1px rgba(0, 0, 0, 0.2);
  }

  table {
    margin-top: 15px;
    width: 100%;
    margin-bottom: 15px;
    background-color: var(--mdc-theme-surface, #fff);
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.12);
    -webkit-overflow-scrolling: touch;
    /*display: inline-flex;*/
    /*border-collapse: collapse;*/
    flex-direction: column;
    border-spacing: 0;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.87);
    table-layout: fixed;
  }

  .tr-head {
    background-color: blanchedalmond;
  }

  td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    font-family: Roboto, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    text-transform: inherit;
  }

  .height {
    height: 46px;
  }

  .padding {
    padding-right: 16px;
    padding-left: 16px;
  }

  .status-pending {
    color: #1472a1;
  }

  .status-verified {
    color: green;
  }

  .status-rejected {
    color: var(--invalid-color);
  }

  .status-expired {
    color: grey;
  }

  /* Tooltip
 *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    /*top: -60px;*/
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    /*position: absolute;*/
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -400px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .fade-in-long {
    animation: transition_in 2.5s;
  }

  .delete-icon {
    position: absolute;
    left: -40px;
    top: 45px;
    cursor: pointer;
    color: var(--invalid-color);
  }

  .cell-pointer {
    cursor: pointer;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    main {
      width: 800px;
      margin: 0 auto;
      height: fit-content;
    }

    .mobile-width {
      width: 20%;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    main {
      width: 90%;
      margin: 0 auto;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    main {
      width: 100%;
      margin: 0 auto;
      height: fit-content;
      margin-bottom: 100px;
      padding: 0;
      border-radius: 0;
    }

    .mdc-card-documents {
      overflow-y: scroll;
    }

    .delete-icon {
      position: absolute;
      left: 128px;
    }

    .mobile-width {
      width: 100%;
      display: block;
      text-align: center;
    }

    .mobile-icon {
      margin-left: 66px;
    }

    .tr-head {
      display: none;
    }

    .td {
      display: block;
      height: 100%;
    }

    .mdc-data-table__row {
      display: block;
    }

    .mdc-data-table__cell:first-child {
      text-align: center;
    }

    .mdc-data-table__cell:before {
      content: attr(data-heading);
    }

    td.mdc-data-table__cell i {
      margin-left: 50%;
    }

    .hide_cancelled {
      display: none;
    }

    .mobile-padding {
      padding: 24px;
      padding-left: 62px;
    }

  }
</style>
